import { Component } from '../lib/ComponentBase';
import { simpleComponent } from '../lib/ComponentHelpers';
import type { ProposalProvider, DisplayProvider, DisplayInfo } from '../types/Components';
import type Action from '../lib/Action';
import type { Proposal } from '../lib/Proposal';
import HexPosition from './HexPosition';
import { ActionType } from '../lib/Action';
import { ProposalType } from '../lib/Proposal';

/**
 * An ability that lets an actor attack an opponent one hex beyond its destination.
 */
class LungeAttack extends Component implements ProposalProvider, DisplayProvider {
  damage: number;
  priority: number;

  constructor(data: { damage?: number, priority?: number } = {}) {
    super();
    this.damage = data.damage ?? 100;
    this.priority = data.priority ?? 15;
  }

  getDisplayInfo(): DisplayInfo {
    return { icon: 'game-icons:charging-bull', label: 'Lunge', description: 'Lunges forward to attack.' };
  }

  getProposedOutcome(selfAction: Action): Proposal | null {
    if (selfAction.type !== ActionType.MOVE || !selfAction.details.coords) {
      return null;
    }

    const selfPos = selfAction.entity.getComponent(HexPosition);
    if (!selfPos) return null;

    // A lunge targets the hex one step beyond the move's destination.
    const lungeDestination = selfAction.details.coords;
    const targetHex = lungeDestination.neighbor(selfPos.bearing);

    const effect = {
      type: 'ATTACK' as const,
      attackHex: targetHex,
      damage: this.damage,
      attackTiming: 'END' as const,
      animationMergeStrategy: 'APPEND' as const,
      animationPlan: [
        [{ type: 'ATTACK_JAB', entityId: selfAction.entity.id, targetCoords: targetHex }],
      ],
    };

    return {
      type: ProposalType.AUGMENT,
      priority: this.priority,
      effects: [effect],
    };
  }
}

export default simpleComponent(LungeAttack);
